<template>
  <section>
    <el-table :data="data" border>
      <el-table-column
        v-for="(step, index) in columns"
        :key="index"
        :label="step.label"
        :width="step.c_width ? step.c_width : 250"
      >
        <template slot-scope="scope">
          <div class="d-flex" v-if="!editableFields.includes(step.key)">
            <component
              v-bind:is="fieldMap[step.input_type]"
              :rules_hide="true"
              :data="{ ...step, key: step.key.split('#')[1] }"
              :form="scope.row.entityData[step.template_id]"
              :is-view="step.inputType == 'FORMULA' ? false : true"
              :fieldsData="fieldsData"
              :entityDataId="scope.row._id"
              :entityId="currentEntity._id"
            ></component>
          </div>
          <div v-else>
            <component
              v-bind:is="fieldMap[step.input_type]"
              :rules_hide="true"
              :data="{ ...step, key: step.key.split('#')[1] }"
              :form="scope.row.entityData[step.template_id]"
              :is-view="false"
              :fieldsData="fieldsData"
              :entityDataId="scope.row._id"
              :entityId="currentEntity._id"
            ></component>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Actions" fixed="right" width="100">
        <template slot-scope="scope">
          <div class="d-flex space-between">
            <div>
              <el-button size="mini" type="primary" @click="addNewRow">+</el-button>
            </div>
            <div>
              <el-button size="mini" type="danger" @click="removeRow(scope.row)">-</el-button>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="entity-detailed-footer">
      <el-row :gutter="5">
        <el-col :sm="24" class="text-right">
          <button class="btn btn-sm btn-outline-danger m-lr-1" @click="closeDialog">
            <i class="fa fa-times"></i>
            Cancel
          </button>
          <button class="btn btn-sm btn-outline-primary m-lr-1" @click="updateData">
            <i class="fa fa-sign-in"></i>
            Ok & Save
          </button>
        </el-col>
      </el-row>
    </div>
    <template v-if="showAddDialog">
      <dialog-component
        :visible="showAddDialog"
        @before-close="showAddDialog = false"
        containerWidth="20%"
        containerHeight="40%"
        title="Add New"
      >
        <template class="p-2">
          <el-select v-model="newRow">
            <el-option
              v-for="option in entityFieldDatas[field.relationship_key]"
              :key="option._id"
              :value="option._id"
              :label="getLabel(option)"
              :disabled="isOptionDislabled(option._id)"
            ></el-option>
          </el-select>
        </template>
        <template slot="footer">
          <el-button type="primary" @click="addRow">Add</el-button>
        </template>
      </dialog-component>
    </template>
  </section>
</template>
<script>
  import { postAPICall } from '../../helpers/httpHelper';
  import { getAllFieldsArrayFromEntity } from '../../utils/formatter';
  import contentParserHelper from '../../mixins/contentParserHelper';
  import CustomDashboardHelper from '../../mixins/CustomDashboardHelper';
  import AutomationHelper from '../../mixins/AutomationHelper';
  import { dataTableAllowedExcecuteFields } from '../templates/formComponentsExecute';
  export default {
    props: ['currentEntity', 'parentData', 'field', 'form', 'entityFieldDatas', 'allFields'],
    data() {
      return {
        columns: [],
        selectedEntityFields: [],
        editableFields: [],
        tableData: [],
        showAddDialog: false,
        newRow: '',
        parentField: {},
        fieldMap: {
          DATE: 'DateExecute',
          FILE: 'FileExecute',
          MULTI_LINE_TEXT: 'MultiLineTextExecute',
          SINGLE_LINE_TEXT: 'SingleLineTextExecute',
          MULTI_SELECT: 'MultiSelectExecute',
          NUMBER: 'NumberExecute',
          SELECT: 'SelectExecute',
          LIST: 'ListExecute',
          YES_OR_NO: 'YesOrNoExecute',
          HEADING: 'HeadingExecute',
          CHECKBOX: 'CheckBoxExecute',
          SIGNATURE: 'ESignatureExecute',
          GLOBAL_VAIRLABE: 'GlobalVariableExecute',
          ENTITY_VARIABLE: 'EntityVariableExecute',
          PARAGRAPH: 'ParagraphExecute',
          SINGLE_LINE_CONTENT: 'SingleLineContentExecute',
          AUTHORIZED_SIGNATURE: 'AuthorizedSignatureExecute',
          IMAGE: 'ImageExecute',
          FORMULA: 'FormulaExecute',
          ACTION_BUTTON: 'ActionButtonExecute',
          HTML: 'HtmlExecute',
          ENTITY: 'EntityExecute',
          CURRENCY: 'CurrencyExecute',
          CURRENCY_TYPE: 'CurrencyTypesExecute',
          PHONE_COUNTRY_CODE: 'PhoneCountryCodeExecute',
          DATE_TIME: 'DateTimeExecute',
          DATE_TIME_RANGE: 'DateTimeRangeExecute',
          DATE_RANGE: 'DateRangeExecute',
          TIME: 'TimeExecute',
          RADIO: 'RadioExecute',
          WEEKDAYS: 'WeekDaysExecute',
          TIME_RANGE: 'TimeRangeExecute',
          CHECKBOX_GROUP: 'CheckBoxGroupExecute',
          AGGREGATE_FUNCTION: 'AggregateFunctionExecute',
          STAR_RATING: 'StarRatingExecute',
          DATA_TABLE: 'DataTableExecute',
          RADIO_BUTTON_GROUP: 'RadioButtonGroupExecute',
          AUTO_INCREMENT_NUMBER: 'AutoIncrementExecute',
          PAY_BUTTON: 'PaymentExecute',
          CONCATENATE: 'ConcatenateExecute',
          RANDOM_TEXT: 'RandomTextExecute',
          ADDRESS: 'AddressExecute',
          LOCATION: 'LocationExecute',
          INTEGRATION: 'IntegrationExecute',
          INTEGRATION_VARIABLE: 'IntegrationVariableExecute',
          PRICE: 'PriceCalculatorExecute',
          SLOT: 'SlotsExecute',
        },
      };
    },
    computed: {
      fieldsData() {
        return this.selectedEntityFields.map((fd) => {
          return {
            ...fd,
            key: fd.key.split('#')[1],
          };
        });
      },
    },
    async mounted() {
      this.parentField = this.allFields.find((fd) => fd.key == this.field.relationship_key);
      if (this.currentEntity) {
        this.selectedEntityFields = this.getAllFieldsFromEntity(this.currentEntity, false);
        this.columns = this.currentEntity.settings.map((s) => {
          let field = this.selectedEntityFields.find((fd) => fd.key == s.template_id + '#' + s.key);
          return {
            ...field,
            properties: {
              ...field.properties,
              filed_content: 'NONE',
            },
            c_width: s.width,
          };
        });
        let field = this.selectedEntityFields.find(
          (fd) => fd.key == this.field.global_variable_entity_field
        );
        if (field.inputType == 'FORMULA') {
          this.collectEditableFields(field);
        } else {
          this.editableFields = [field.key];
        }
        await this.fetchEntityData();
      }
    },
    mixins: [contentParserHelper, CustomDashboardHelper, AutomationHelper],
    components: {
      ...dataTableAllowedExcecuteFields,
    },
    methods: {
      collectEditableFields(field) {
        field.selected_fields.forEach((fd) => {
          if (fd.type === 'FIELD') {
            this.editableFields.push(field.template_id + '#' + fd.key);
          } else if (fd.type === 'FORMULA') {
            let formulaField = this.selectedEntityFields.find(
              (f) => f.key === field.template_id + '#' + fd.key
            );
            if (formulaField?.selected_fields?.length) {
              this.collectEditableFields(formulaField);
            }
          }
        });
      },
      getLabel(data) {
        let label = '';
        this.parentField.primary_fields.forEach((pf, i) => {
          let [t, k] = pf.split('#');
          label += (i == 0 ? '' : ' - ') + data.entityData[t][k];
        });
        return label;
      },
      async addRow() {
        let params = {
          entity_id: this.currentEntity._id,
          page: 1,
          limit: 50,
          entity_data_ids: [this.newRow],
          template_fields_data: getAllFieldsArrayFromEntity(this.currentEntity),
          format_data: true,
        };
        let response = await postAPICall('POST', '/entities-data/entity/data/v2', params);
        if (response.data.data.length) {
          this.tableData.push(response.data.data[0]);
          this.$set(
            this.form,
            this.field.relationship_key,
            this.tableData.map((dt) => dt._id)
          );
        }
        this.newRow = '';
        this.showAddDialog = false;
      },
      isOptionDislabled(id) {
        return this.tableData.map((dt) => dt._id).includes(id);
      },
      addNewRow() {
        this.newRow = '';
        this.showAddDialog = true;
      },
      removeRow(data) {
        this.tableData = this.tableData.filter((row) => row._id != data._id);
        this.$set(
          this.form,
          this.field.relationship_key,
          this.tableData.map((dt) => dt._id)
        );
      },
      async fetchEntityData() {
        if (this.parentData.length) {
          let params = {
            entity_id: this.currentEntity._id,
            page: 1,
            limit: 50,
            entity_data_ids: this.parentData,
            template_fields_data: getAllFieldsArrayFromEntity(this.currentEntity),
            format_data: true,
          };
          let response = await postAPICall('POST', '/entities-data/entity/data/v2', params);
          if (response.data.data.length) {
            this.tableData = JSON.parse(JSON.stringify(response.data.data));
          }
        }
      },
      updateData() {
        this.$emit('updateData', this.tableData);
      },
      closeDialog() {
        this.$emit('closeDialog');
      },
    },
  };
</script>
<style>
  .entity-detailed-footer {
    flex-shrink: 0;
    background: #fff;
    padding: 5px;
  }
</style>
